// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8jzuO","question":"styles_question__3N2Nk","inputVisibleButton":"styles_inputVisibleButton__15_V1","note":"styles_note__1u8Ou"};